import { Guid } from "guid-typescript";
import { IMessage } from "../../../IMessage";

//Generated code, do not modify

export class ArchiveEventCommand implements IMessage {
    id!: Guid;

    public constructor(init?: Partial<ArchiveEventCommand>) {
        Object.assign(this, init);
    }

    getMethod = () => "PUT";

    getUrl = () => `/admin/events/${this.id.toString()}/archive`;

    getQueryString = () => undefined;

    getBody = () => undefined;
}